export default {
  noActiveRecipe: 'Brak aktywnej receptury na tym piecu.',
  confirmSave: {
    header: 'Zapisać wartości zadane?',
    message: 'Wartości zadane zostaną przesłane do pieca, a jego bieżące wartości zadane zostaną zresetowane do tych wartości.',
  },
};
